import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { MatDialog, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { SpotOnDriverComponent } from '../spot-on-driver/spot-on-driver.component';
import { Subscription, Subject } from 'rxjs';
import { EventService } from '../event.service';
import { Messages } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ValidationService } from '../validation.service';



@Component({
  selector: 'app-spot-drivers',
  templateUrl: './spot-drivers.component.html',
  styleUrls: ['./spot-drivers.component.scss']
})
export class SpotDriversComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('optIn', { static: true }) optIn: TemplateRef<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("openVideos", { static: true }) openVideos: TemplateRef<any>;


  video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ADDING_SPOT_DRIVER);
  columnsToDisplay = ['name', 'mobile', 'vehicleNumber', 'vehicleType', 'carrier', 'action'];
  spotDrivers = [
    // {name: 'gsgsg', mobile: 'sdgsg', vehicleNumber: 'dsfdsf', vehicleType: 'sdfgds', carrier: 'dadgcv', action: ''},
    // {name: 'gsgsg', mobile: 'sdgsg', vehicleNumber: 'dsfdsf', vehicleType: 'sdfgds', carrier: 'dadgcv', action: ''},
    // {name: 'gsgsg', mobile: 'sdgsg', vehicleNumber: 'dsfdsf', vehicleType: 'sdfgds', carrier: 'dadgcv', action: ''},
    // {name: 'gsgsg', mobile: 'sdgsg', vehicleNumber: 'dsfdsf', vehicleType: 'sdfgds', carrier: 'dadgcv', action: ''},
  ];

  VideoLinkRef: any;
  carrierId: Subscription;
  driverFilters: any = {};
  totalDrivers = 0;
  optInData: any;
  optInRef;
  errors = new Messages();
  driversList: MatTableDataSource<any>;
  filterValue = '';
  searchText = '';
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  name = '';
  mobile = '';
  vehicleNo = '';
  vehicleType = '';
  allVehicles = [];
  showLoader = false;
  subscription: Subscription;
  searchTextChanged = new Subject<object>();
  filters: any = {
    name: '',
    mobile: '',
    vehicle_no: ''
  };
  constructor(private changeDetection: ChangeDetectorRef, private valid: ValidationService,private snackbar: SnackbarService,private route: Router,private snackBar: SnackbarService, private translation: TranslateService, private http: HttpService, private dialog: MatDialog, private event: EventService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getSpotDrivers();
    this.getVehicleTypes();
   
    this.carrierId = this.event.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getSpotDrivers();
        this.getVehicleTypes();
      }
    );

  }
  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
  getSpotDrivers(filter: any = {}) {
    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.spotDrivers = [];
    this.showLoader = true;
    this.http.get('driver/spot_on', filter).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          const result = data.data.drivers;
          this.totalDrivers = data.data.count;
          result.forEach(element => {
            const temp: any = {};
            temp.name = element.name;
            temp.mobile = element.mobile;
            temp.SecondaryMobile = element.mobile2;
            temp.vehicleNumber = element.vehicle_no;
            temp.vehicleType = element.vehicle_type.name;
            temp.vehicleId = element.vehicle_type._id;
            temp.carrier = element.carrier.name;
            temp.whatsApp = element.ws_opt_in;
            temp.gps_provider = element.gps ? element.gps.provider : '';
            temp.id = element._id;
            this.spotDrivers.push(temp);
          });
          if (!this.driversList) {
            this.driversList = new MatTableDataSource(this.spotDrivers);
            this.driversList.sort = this.sort;
            this.driversList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
          } else {
            this.driversList = new MatTableDataSource(this.spotDrivers);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
          }
        }

      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
      }
    );
  }
  openSpotDriver() {
    const dialogRef = this.dialog.open(SpotOnDriverComponent);
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if (data && data.statusCode === 200) {
          this.getSpotDrivers();
        }
      }
    );
  }

  openEditDriver(driver: any = '') {
    const data: any = {
      editDriver: true
    };
    if (driver) {
      data.driverData = driver;
    }
    const dialogRef = this.dialog.open(SpotOnDriverComponent, {
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getSpotDrivers();
      }
    });
  }

  pageNavigate(event) {
    this.driverFilters.limit = event.pageSize;
    this.driverFilters.skip = event.pageIndex * event.pageSize;
    this.getSpotDrivers(this.driverFilters);
  }
  whatsapp() {
    const dataa = {
      driver: this.optInData.id
    };
    this.http.post('driver/spot_on/ws_opt_in', dataa).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.errors.DRIVERS.DIALOGDATA.OPTIN, '');
          this.optInRef.close();
          this.getSpotDrivers();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  optInWa(element) {
    this.optInData = element;
    this.optInRef = this.dialog.open(this.optIn);
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getSpotDrivers(x);
    });
    this.changeDetection.detectChanges();
  }
  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    if (value.length) {
      switch (type) {
        case 'name':
          this.driverFilters.name = value;
          break;
        case 'mobile':
          this.driverFilters.mobile = value;
          break;
        case 'vehicle_no':
          this.driverFilters.vehicle_no = value;
          break;
        case 'vehicle_type':
          this.driverFilters.vehicle_type = value;
          break;
      }
      this.reSubscribe();
      this.searchTextChanged.next(this.driverFilters);
    } else {
      this.clearFilter(type);
    }
  }
  clearFilter(type) {
    switch (type) {
      case 'name':
        delete this.driverFilters.name;
        break;
      case 'mobile':
        delete this.driverFilters.mobile;
        break;
      case 'vehicle_no':
        delete this.driverFilters.vehicle_no;
        break;
      case 'vehicle_type':
        delete this.driverFilters.vehicle_type;
        break;
    }
    this.getSpotDrivers(this.driverFilters);
  }
  applyFilter(value, type) {
    this.driverFilters = {};
    this.filterValue = value;
    if (value !== '') {
      if (type === 'name') {
        this.driverFilters.name = value;
      }
      if (type === 'mobile') {
        this.driverFilters.mobile = value;
      }
      if (type === 'vehicle_no') {
        this.driverFilters.vehicle_no = value;
      }
    }
    this.getSpotDrivers(this.driverFilters);
  }
  vehiclesearch(value) {
    if (this.driverFilters.vehicle_type !== '') {
      this.driverFilters.vehicle_type = '';
    } else {
      this.driverFilters.vehicle_type = value;
      this.getSpotDrivers(this.driverFilters);
    }
  }
  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.vehicle_types.length) {
            this.allVehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  clear() {
    this.name = '';
    this.mobile = '';
    this.vehicleNo = '';
    this.vehicleType = '';
    this.getSpotDrivers();
  }

  openVideoLink() {

    this.VideoLinkRef = this.dialog.open(this.openVideos, {

    });
  }
  openVehicleMapView() {
    this.route.navigateByUrl('vehicle-map-view');
  }

}
